import { createContext, useState } from "react";
import PropTypes from "prop-types";

export const SideBarContext = createContext();

const SideBarContextProvider = (props) => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [selectedTab, setselectedTab] = useState("");
  const [isPinned, setIsPinned] = useState(false);

  return (
    <SideBarContext.Provider value={{ openSidebar, setOpenSidebar, selectedTab, setselectedTab, isPinned, setIsPinned }}>
      {props.children}
    </SideBarContext.Provider>
  );
};

export default SideBarContextProvider;

SideBarContextProvider.propTypes = {
  children: PropTypes.any,
};
